import {
  DescriptionContainer,
  DescriptionTitle,
  DescriptionSubtitle,
} from './styles'

export function Description({
  title,
  subtitle,
  padding = '8%',
  id,
  textTransform = 'none',
  children = null,
  widthDescriptionTitle = '100%',
  titlePosition = 'center',
  textPosition = 'center',
}) {
  return (
    <DescriptionContainer id={id} className="description-container">
      {title && (
        <DescriptionTitle
          className="description-title"
          as="h2"
          textTransform={textTransform}
          width={widthDescriptionTitle}
          titlePosition={titlePosition}
          titleAlign={textPosition}
        >
          {children || null}
          {title}
        </DescriptionTitle>
      )}
      {subtitle && (
        <DescriptionSubtitle
          textPosition={titlePosition}
          textAlign={textPosition}
          padding={padding}
          className="description-subtitle"
        >
          {subtitle}
        </DescriptionSubtitle>
      )}
    </DescriptionContainer>
  )
}
